import { Input, Typography } from '@smartgift/frontend-toolkit';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { MAX_SUBJECT_LENGTH } from '@hero/constants';

import * as S from './style';

function ShareViaEmail({
  setPrimaryButtonText,
  setSecondaryButtonText,
  setPrimaryButtonDisabled,
  sendEmailSubject,
  setSendEmailSubject,
  experienceSettings
}) {
  const { t } = useTranslation();

  useEffect(() => {
    setPrimaryButtonText(t('confirm'));
    setSecondaryButtonText(t('back'));
  }, []);

  return (
    <S.ShareTypeWrapper>
      <S.SelectionContent>
        <Typography variant="body1Bold">{`${t('shareViaEmailSubjectLine')}:`}</Typography>
        <Input
          value={sendEmailSubject}
          name="subject"
          inputProps={{
            onChange: e => {
              setSendEmailSubject(e.target.value);
              setPrimaryButtonDisabled(e.target.value.length === 0);
            },
            maxLength: MAX_SUBJECT_LENGTH
          }}
          label={`${t('subjectLine')}*`}
          required
        />
      </S.SelectionContent>
      <S.PreviewFrame>
        <S.PreviewFrameText>{sendEmailSubject}</S.PreviewFrameText>
        <S.PreviewFrameSenderName>
          {experienceSettings?.messageParams?.senderName}
        </S.PreviewFrameSenderName>
      </S.PreviewFrame>
    </S.ShareTypeWrapper>
  );
}

export default ShareViaEmail;
